import React from 'react'

export default function FourOhFourPage() {
    return (
        <div>
              <h1>404 Not Found</h1>
              <img src="https://2xom5j4aqh9o3quhfzkge6t1-wpengine.netdna-ssl.com/wp-content/uploads/2012/01/404-no-jobs-600x285.png"/>
        </div>
    )
}
